import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function DollarIcon(props) {
  const width = props.width || 30;
  const height = props.height || 30;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0976 20.5813C19.4581 22.3591 17.1091 23.4727 14.5 23.4727C9.5445 23.4727 5.52727 19.4555 5.52727 14.5C5.52727 12.7567 6.02444 11.1295 6.88473 9.75245L10.8542 12.7768C11.0826 13.2262 11.4196 13.5877 11.8162 13.8786C12.2602 14.2042 12.7856 14.4458 13.3042 14.6434L13.9273 15.1182V18.5024C12.9615 18.4606 11.89 18.2246 10.9412 17.8818L10.223 17.6223L9.70409 19.0588L10.4223 19.3182C11.4791 19.7 12.7351 19.9882 13.9273 20.0308V21.1819V21.7546H15.0727V21.1819V19.9878C15.13 19.9809 15.1868 19.9732 15.2432 19.9647C16.0118 19.8495 16.7693 19.5772 17.3421 19.0357C17.5994 18.7924 17.8049 18.5086 17.9552 18.1871L21.0976 20.5813ZM22.0342 19.3749C22.9443 17.9713 23.4727 16.2974 23.4727 14.5C23.4727 9.5445 19.4555 5.52727 14.5 5.52727C11.8366 5.52727 9.4443 6.68769 7.801 8.5305L10.6175 10.6764C10.7714 10.0363 11.1382 9.53329 11.6464 9.17501C12.2872 8.72317 13.1018 8.53438 13.8763 8.47884L13.9273 8.47537V7.81824V7.24552H15.0727V7.81824V8.48574C16.2511 8.5752 17.4026 8.88916 18.0895 9.26696L18.7586 9.63496L18.0227 10.9732L17.3535 10.6052C16.9007 10.3562 16.0151 10.1038 15.0727 10.018V13.6375C15.7026 13.849 16.3862 14.0973 16.9362 14.4518C17.6116 14.887 18.1585 15.529 18.2421 16.4857L22.0342 19.3749ZM13.9273 13.1981L12.1159 11.8181C12.082 11.6869 12.0644 11.5421 12.0644 11.3803C12.0644 10.8989 12.2461 10.6209 12.5265 10.4232C12.8379 10.2036 13.3177 10.0571 13.9273 10.0067V13.1981ZM15.0727 15.9909L16.6795 17.2152C16.6096 17.538 16.4669 17.7614 16.2929 17.9258C16.033 18.1715 15.6291 18.3545 15.0727 18.4456V15.9909ZM14.5 25C20.299 25 25 20.299 25 14.5C25 8.70101 20.299 4 14.5 4C8.70101 4 4 8.70101 4 14.5C4 20.299 8.70101 25 14.5 25Z"
          fill="url(#paint0_linear_dollar)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_dollar"
            x1="4"
            y1="8.55422"
            x2="14.1089"
            y2="29.2097"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
